export const env = {
    primeBridgeUrl: process.env.REACT_APP_PRIME_BRIDGE_SERVICE_URI,
    pbTrackingUrl: process.env.REACT_APP_PB_TRACKING_URI,
    baseUrl: process.env.REACT_APP_BASE_URI,
    portalUrl: process.env.REACT_APP_PORTAL_URI,
}
